import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { BreadCrumbs } from '@lanl-web/lanl-components';

import './ContentContainer.scss';

export const ContentContainer = ({
  children,
  className,
  location,
  showBreadCrumb,
}) => {
  const classes = classNames('content-container', className);

  return (
    <div className={classes}>
      {showBreadCrumb && (
        <BreadCrumbs homeName='Dashboard' location={location} />
      )}
      <div>{children}</div>
    </div>
  );
};

ContentContainer.defaultProps = {
  location: {},
  showBreadCrumb: false,
};

ContentContainer.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
  className: PropTypes.string,
  showBreadCrumb: PropTypes.bool,
};

export default ContentContainer;
